import React from 'react'
import { Card, Flex } from 'antd'
import { useParams } from 'react-router'
import fileDownload from 'js-file-download'
import { useSelector } from 'react-redux'
import FeedbackModificationStatsChart from './FeedbackModificationStatsChart'
import { useLazyExportFeedbackModificationStatsQuery } from '../../../../../../../store/apis/analytics.api'
import assignmentSelectors from '../../../../../../../store/selectors/assignment.selectors'
import ExportDropdownButton from '../../../../../../../components/common/export/ExportDropdownButton'

const FeedbackModificationStatsCard = () => {
    const { token } = useParams()
    const assignmentName = useSelector(assignmentSelectors.name)

    const [exportFeedbackModificationStats, exportResult] = useLazyExportFeedbackModificationStatsQuery()

    const handleExport = async format => {
        const response = await exportFeedbackModificationStats({
            token,
            format,
        })

        if ('data' in response) {
            const fileExtension = format.toLowerCase() === 'xlsx' ? 'xlsx' : 'csv'
            fileDownload(response.data, `${assignmentName}_feedback_modification_stats.${fileExtension}`)
        }
    }

    const extra = (
        <Flex align='center' gap={8}>
            <ExportDropdownButton
                onExport={handleExport}
                formats={['csv', 'xlsx']}
                loading={exportResult.isLoading}
                buttonText='Export'
            />
        </Flex>
    )

    return (
        <Card title='Feedback Modification Statistics' extra={extra}>
            <FeedbackModificationStatsChart token={token} />
        </Card>
    )
}

export default FeedbackModificationStatsCard

